import {
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  Grid,
} from "@mui/material"
import React from "react"

type ComponentProps = {
  question: string
  ans1: string
  ans2: string
  label1: string
  label2: string
  value: string
  required: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

function RadioQuestion(props: ComponentProps) {
  const { question, ans1, ans2, label1, label2, value, onChange, required } =
    props
  return (
    <FormControl
      required={required}
      sx={{
        width: "100%",
        padding: "10px",
        paddingBottom: "0px",
        paddingTop: "0px",
      }}
    >
      <FormLabel
        sx={{
          color: "#6F7482",
          fontSize: "16px",
        }}
      >
        {question}
      </FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={value}
        onChange={onChange}
      >
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <FormControlLabel value={ans1} control={<Radio />} label={label1} />
          </Grid>

          <Grid item xs={6}>
            <FormControlLabel value={ans2} control={<Radio />} label={label2} />
          </Grid>
        </Grid>
      </RadioGroup>
    </FormControl>
  )
}

export default RadioQuestion
